import React from "react";

import { FormControl, FormHelperText, OutlinedInput } from "@material-ui/core";

import WrappedMaskedInput from "./WrappedMaskedInput";

import { MaskedTextFieldProps } from "./types";

const MaskedTextField: React.FC<MaskedTextFieldProps> = ({
  mask,
  placeholder,
  helperText,
  error = false,
  inputProps = {},
  helperTextProps = {},
  ...rest
}) => (
  <div>
    <FormControl fullWidth variant="outlined" error={error}>
      <OutlinedInput
        fullWidth
        placeholder={placeholder}
        inputProps={{ mask, ...inputProps }}
        inputComponent={WrappedMaskedInput as any}
        {...rest}
      ></OutlinedInput>
      {helperText && (
        <FormHelperText {...helperTextProps}>{helperText}</FormHelperText>
      )}
    </FormControl>
  </div>
);

export default MaskedTextField;
